import React from 'react';
import Header from '../../components/Layout/Header';
import './Department.css';

const IT: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Information Technology Department</h1>
          <p className="department-description">
            Welcome to the IT Department page. Here you can find information about technology services, 
            system updates, and IT support resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About IT Department</h3>
            <p>
              The Information Technology Department manages all technology infrastructure, systems, 
              and provides technical support to ensure smooth operations across the organization.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>System Administration</li>
              <li>Network Management</li>
              <li>Software Development</li>
              <li>IT Support and Helpdesk</li>
              <li>Cybersecurity</li>
              <li>Data Management</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For IT-related inquiries and support, please contact the IT Department.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IT;

